import { addHttpToUrl } from "../../../../utils/addHttpToUrl";

// Design (24) 8640-8655 / 20605-20618: the Invoice Footer Notes line points
// to the Cancellation and Refund Policy page on the chamber's CMP website.
export const CANCELLATION_REFUND_POLICY_PATH = "/cancellation-refund-policy";

export const INVOICE_FOOTER_NOTES_MISSING_WEBSITE_TEXT =
  "Your Chamber Member Pro website address is not set up yet.";

const CMP_WEBSITE_PLATFORM_ROOT_HOST = "chambermemberpro.com";

// Same rule as cap-backend getCanonicalWebsiteBuilderHost (tenantHost): the
// website redirects only `www.<tenant>.chambermemberpro.com` to the host
// without `www`. Custom domains keep `www` as configured.
const getCanonicalWebsiteHost = (hostname: string): string => {
  const labels = hostname.toLowerCase().split(".");
  const rootLabels = CMP_WEBSITE_PLATFORM_ROOT_HOST.split(".");

  if (
    labels.length === rootLabels.length + 2 &&
    labels[0] === "www" &&
    labels.slice(2).join(".") === CMP_WEBSITE_PLATFORM_ROOT_HOST
  ) {
    return labels.slice(1).join(".");
  }

  return hostname.toLowerCase();
};

// Website origin + policy path, or "" when the address is missing or invalid.
// addHttpToUrl trims, adds https:// when there is no scheme, and rejects
// anything that is not a plain http(s) address.
export const getCancellationRefundPolicyUrl = (
  websiteUrl: string | null | undefined
): string => {
  const normalizedUrl = addHttpToUrl(websiteUrl);
  if (!normalizedUrl) {
    return "";
  }

  const parsedUrl = new URL(normalizedUrl);
  parsedUrl.hostname = getCanonicalWebsiteHost(parsedUrl.hostname);
  return `${parsedUrl.origin}${CANCELLATION_REFUND_POLICY_PATH}`;
};

export const getInvoiceFooterNotesText = (
  websiteUrl: string | null | undefined
): string => {
  const policyUrl = getCancellationRefundPolicyUrl(websiteUrl);

  return policyUrl
    ? `To see our Cancellation and Refund Policy, go to ${policyUrl}`
    : INVOICE_FOOTER_NOTES_MISSING_WEBSITE_TEXT;
};
